<template>
  <div>
    <div
      style="background: rgb(163, 219, 213)"
      v-if="LoadingSkeleton"
      class="topNav"
    >
      <Skeletor
        style="background: rgb(163, 219, 213); width: 100% !important"
        class="topNav__container"
      />
    </div>

    <div
      v-if="!LoadingSkeleton"
      :class="[
        classShow,
        {
          mobileFirstPageNav:
            $route.path === '/' ||
            $route.path === '/home' ||
            $route.path === '/map-house' ||
            $route.path === '/map-amlak',
        },
      ]"
      :style="showMenu ? { boxShadow: 'none' } : {}"
    >
      <div class="static stickyBarStaticSticky">
        <div class="topNav__container">
          <div class="topNav__containerLogo">
            <router-link to="/" class="topNav__logo-wrapper">
              <img
                src="../../assets/img/shomalamlak.gif"
                alt="Nav Logo"
                class="topNav_logo logoPic"
              />
            </router-link>
          </div>
          <div
            class="topNav__container_column topNav__container_column--flex-between topNav__container_column--left"
          >
            <div class="topNav__links_container">
              <router-link
                to="/home"
                class="topNav__link"
                :class="{ activeLink: $route.path == '/home' }"
                >خانه</router-link
              >
              <router-link
                to="/map-house?main_cat=all&cat=all"
                class="topNav__link"
                :class="{ activeLink: $route.path == '/map-house' }"
                >جست و جو در نقشه</router-link
              >
              <router-link
                v-if="$store.getters.auth.loggedIn"
                to="/bookmark"
                class="topNav__link"
                :class="{ activeLink: $route.path == '/bookmark' }"
                >ذخیره</router-link
              >
              <router-link
                to="/amlak-list"
                class="topNav__link"
                :class="{ activeLink: $route.path == '/amlak-list' }"
                >مشاوران املاک</router-link
              >
              <router-link
                to="/category?main_cat=all&cat=all"
                class="topNav__link"
                :class="{
                  activeLink: $route.path == '/category',
                }"
                >همه آگهی‌ها</router-link
              >
            </div>
            <VsxIcon
              @click="BtnOpenSidebar"
              style="cursor: pointer"
              iconName="HambergerMenu"
              :size="28"
              color="#000000"
              type="linear"
              class="menuToggling"
            />
          </div>

          <div
            class="topNav__container_column topNav__container_column--flex-left"
          >
            <div class="reMenuToggler">
              <VsxIcon
                @click="BtnOpenSidebar"
                style="cursor: pointer"
                iconName="HambergerMenu"
                :size="28"
                color="#000000"
                type="linear"
              />
            </div>
            <p class="ShowToUSerDateDay">{{ formattedDate }}</p>

            <!-- <div
              class="ShowWeatherBabol"
              v-if="weather && weather.current_weather"
            >
              <p>{{ weather.current_weather.temperature }} °C</p>

              <VsxIcon
                :iconName="getWeatherIcon(weather.current_weather.weathercode)"
                :size="28"
                :color="$route.path === '/' ? '#57cc99' : '#5584FF'"
                type="linear"
              />
            </div> -->
            <div class="topNav__themeButton_wrapper1">
              <div
                class="topNav__themeButton_wrapper mr-24"
                @click="changeTheme"
              >
                <div
                  class="switchDark switch_icon"
                  :class="{ show: !darkTheme }"
                >
                  <VsxIcon
                    iconName="Moon"
                    :size="20"
                    color="#000000"
                    type="linear"
                  />
                </div>
                <div class="changeTheme__switch">
                  <div
                    class="switchToggle"
                    :class="{ fisrtPageNav: $route.path === '/' }"
                    :style="themeSwithToggleStyle"
                  >
                    <VsxIcon
                      v-if="darkTheme"
                      iconName="Moon"
                      :size="12"
                      color="#fff"
                      type="linear"
                      class="IconVsLiner"
                    />

                    <VsxIcon
                      v-if="!darkTheme"
                      iconName="Sun1"
                      :size="12"
                      color="#fff"
                      type="linear"
                      class="IconVsLiner"
                    />
                  </div>
                </div>
                <div
                  class="switchLight switch_icon"
                  :class="{ show: darkTheme }"
                >
                  <VsxIcon
                    iconName="Sun1"
                    :size="20"
                    color="#000000"
                    type="linear"
                  />
                </div>
              </div>
            </div>
            <div class="ShowUserTemplate1">
              <div
                v-if="!$store.state.auth.loggedIn"
                @click="$store.state.login_modal = true"
                class="ShowUserTemplate"
              >
                ورود / ثبت نام
              </div>

              <div @click="open_profile()" v-if="$store.state.auth.loggedIn">
                <div class="ShowUserTemplate">پروفایل من</div>
              </div>
            </div>
            <div @click="routBack" class="routBackBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div @click="BtnCloseSidebar" :style="SliderBar" class="BackgroundHover">
        <div @click.stop :style="menuStyles" class="SliderBarMenu">
          <div class="TopMenuUserProfile">
            <div class="TopMenuUserProfileContainer">
              <div
                v-if="!$store.state.auth.loggedIn"
                @click="($store.state.login_modal = true), handleData()"
                class="ShowUserTemplate"
              >
                ورود / ثبت نام
              </div>

              <div
                v-if="$store.state.auth.loggedIn"
                @click="handleData(), open_profile()"
              >
                <div class="ShowUserTemplate">پروفایل من</div>
              </div>

              <div class="menuBarIconWrapper">
                <div class="topNav__themeButton_wrapper1">
                  <div class="topNav__themeButton_wrapper mr-24">
                    <div class="switchDark switch_icon">
                      <VsxIcon
                        iconName="Moon"
                        :size="20"
                        color="#000000"
                        type="linear"
                      />
                    </div>
                    <div class="changeTheme__switch" @click="changeTheme">
                      <div class="switchToggle" :style="themeSwithToggleStyle">
                        <VsxIcon
                          v-if="darkTheme"
                          iconName="Moon"
                          :size="12"
                          color="#fff"
                          type="linear"
                          class="IconVsLiner"
                        />

                        <VsxIcon
                          v-if="!darkTheme"
                          iconName="Sun1"
                          :size="12"
                          color="#fff"
                          type="linear"
                          class="IconVsLiner"
                        />
                      </div>
                    </div>
                    <div class="switchLight switch_icon">
                      <VsxIcon
                        iconName="Sun1"
                        :size="20"
                        color="#000000"
                        type="linear"
                      />
                    </div>
                  </div>
                </div>
                <div @click="BtnCloseSidebar" class="closeBtn">
                  <i class="fa-solid fa-xmark"></i>
                </div>
              </div>
            </div>
          </div>

          <el-scrollbar height="100%">
            <div class="slideBarLinks">
              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/home' }"
                  :style="
                    $route.path == '/home'
                      ? 'background-color: #0096c7 ; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/home')"
                >
                  <VsxIcon
                    :color="$route.path == '/home' ? '#ffffff' : '#000000'"
                    class="slideBarLinkIcon"
                    iconName="Home"
                    :size="24"
                    :type="$route.path == '/home' ? 'bold' : 'linear'"
                  />
                  <span> خانه</span>
                </div>
              </div>

              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/map-house' }"
                  :style="
                    $route.path == '/map-house'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/map-house?main_cat=all&cat=all')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Map"
                    :size="24"
                    :color="$route.path == '/map-house' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/map-house' ? 'bold' : 'linear'"
                  />

                  <span> جست و جو در نقشه </span>
                </div>
              </div>

              <div
                v-if="
                  $store.getters.auth.loggedIn && $store.state.c_set.has_credit
                "
                class="slideBarLink"
              >
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/wallet' }"
                  :style="
                    $route.path == '/wallet'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/wallet')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Wallet1"
                    :size="24"
                    :color="$route.path == '/wallet' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/wallet' ? 'bold' : 'linear'"
                  />
                  <span> کیف پول</span>
                </div>
              </div>

              <div
                v-if="
                  $store.getters.auth.loggedIn && $store.state.c_set.has_credit
                "
                class="slideBarLink"
              >
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/payment-list' }"
                  :style="
                    $route.path == '/payment-list'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/payment-list')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Money4"
                    :size="24"
                    :color="
                      $route.path == '/payment-list' ? '#ffffff' : '#000000'
                    "
                    :type="$route.path == '/payment-list' ? 'bold' : 'linear'"
                  />
                  <span> پرداخت‌های من</span>
                </div>
              </div>

              <div v-if="$store.getters.auth.loggedIn" class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/bookmark' }"
                  :style="
                    $route.path == '/bookmark'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/bookmark')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Save2"
                    :size="24"
                    :color="$route.path == '/bookmark' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/bookmark' ? 'bold' : 'linear'"
                  />
                  <span>ذخیره</span>
                </div>
              </div>

              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/category' }"
                  :style="
                    $route.path == '/category'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/category?main_cat=all&cat=all')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="TableDocument"
                    :size="24"
                    :color="$route.path == '/category' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/category' ? 'bold' : 'linear'"
                  />
                  <span>همه آگهی‌ها</span>
                </div>
              </div>
              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/amlak-list' }"
                  :style="
                    $route.path == '/amlak-list'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/amlak-list')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="HomeHashtag"
                    :size="24"
                    :color="
                      $route.path == '/amlak-list' ? '#ffffff' : '#000000'
                    "
                    :type="$route.path == '/amlak-list' ? 'bold' : 'linear'"
                  />
                  <span>مشاوران املاک</span>
                </div>
              </div>
              <div v-if="$store.getters.auth.loggedIn" class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/submit-house' }"
                  :style="
                    $route.path == '/submit-house'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/submit-house?step=1')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="DocumentUpload"
                    :size="24"
                    :color="
                      $route.path == '/submit-house' ? '#ffffff' : '#000000'
                    "
                    :type="$route.path == '/submit-house' ? 'bold' : 'linear'"
                  />
                  <span> ثبت آگهی</span>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.auth.loggedIn &&
                  $store.getters.auth.role == 'builder'
                "
                class="slideBarLink"
              >
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/builder-create-post' }"
                  :style="
                    $route.path == '/builder-create-post'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/builder-create-post')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="AddSquare"
                    :size="24"
                    :color="
                      $route.path == '/builder-create-post'
                        ? '#ffffff'
                        : '#000000'
                    "
                    :type="
                      $route.path == '/builder-create-post' ? 'bold' : 'linear'
                    "
                  />
                  <span> ثبت پروژه</span>
                </div>
              </div>

              <!-- <div v-if="$store.getters.auth.loggedIn" class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/complaint-tracking' }"
                  :style="
                    $route.path == '/complaint-tracking'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/complaint-tracking')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="SmsTracking"
                    :size="24"
                    :color="
                      $route.path == '/complaint-tracking'
                        ? '#ffffff'
                        : '#000000'
                    "
                    :type="
                      $route.path == '/complaint-tracking' ? 'bold' : 'linear'
                    "
                  />
                  <span>پیگیری شکایت</span>
                  <div
                    v-if="
                      $store.state.c_set.complaint_count != 0 &&
                      $store.state.c_set.complaint_count != ''
                    "
                    class="chatNum"
                  >
                    {{ $store.state.c_set.complaint_count }}
                  </div>
                </div>
              </div> -->
              <div v-if="$store.getters.auth.loggedIn" class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/chat' }"
                  :style="
                    $route.path == '/chat'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/chat')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Messages1"
                    :size="24"
                    :color="$route.path == '/chat' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/chat' ? 'bold' : 'linear'"
                  />
                  <span> چت‌های من</span>
                  <div
                    v-if="$store.state.auth.chat_notseen != 0"
                    class="chatNum"
                  >
                    {{ $store.state.auth.chat_notseen }}
                  </div>
                </div>
              </div>
              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/contact-us' }"
                  :style="
                    $route.path == '/contact-us'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/contact-us')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="Call"
                    :size="22"
                    :color="
                      $route.path == '/contact-us' ? '#ffffff' : '#000000'
                    "
                    :type="$route.path == '/contact-us' ? 'bold' : 'linear'"
                  />
                  <span>تماس با پشتیبانی</span>
                </div>
              </div>

              <div class="slideBarLink">
                <div
                  class="sidebarLinkBtn"
                  :class="{ activeLink: $route.path == '/about-us' }"
                  :style="
                    $route.path == '/about-us'
                      ? 'background-color: #0096c7; color: #fff'
                      : ''
                  "
                  @click="handleLinkClick('/about-us')"
                >
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="InfoCircle"
                    :size="22"
                    :color="$route.path == '/about-us' ? '#ffffff' : '#000000'"
                    :type="$route.path == '/about-us' ? 'bold' : 'linear'"
                  />
                  <span>درباره ما</span>
                </div>
              </div>
              <div class="slideBarLink">
                <div class="sidebarLinkBtn" @click="shareContent">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22px"
                    height="22px"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                    style="margin-left: 16px"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                    />
                  </svg>
                  <span>اشتراک گذاری اپ</span>
                </div>
              </div>
              <div class="slideBarLink" v-if="$store.state.auth.loggedIn">
                <div class="sidebarLinkBtn" @click="profileLogoutHandler">
                  <VsxIcon
                    class="slideBarLinkIcon"
                    iconName="LogoutCurve"
                    :size="22"
                    color="#000000"
                    type="linear"
                  />
                  <span>خروج از حساب کاربری</span>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue3-perfect-scrollbar/style.css";
import { Skeletor } from "vue-skeletor";
import moment from "moment-jalaali";
moment.locale("fa");
// import axios from "axios";
import { mapState } from "vuex";
import { toast } from "vue3-toastify";
import { Share } from "@capacitor/share";

export default {
  components: {
    Skeletor,
  },
  data() {
    return {
      menuStyles: "transform: translateX(100%);",
      SliderBar: "left: 100%",
      darkTheme: false,
      TopNavToClass: true,
      classShow: "topNav",
      themeSwithToggleStyle: "left:5%",
      LoadingSkeleton: true,
      // weather: null,
      isScrolled: false,
      showMenu: false,
      currentDay: moment().format("jYYYY/jMM/jDD"),
      showHafez: false,
      hafezPoem: [],
      interpretation: "",
      window_width: window.innerWidth,
      dynamicClass: "stickyBarStatic",
      lastScrollPosition: 0,
      currentDate: new Date(),
      menuBackAction: false,
      isBackAction: false,
      branchInfo: null,
      persianMonths: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
    };
  },
  computed: {
    formattedPoem() {
      return this.hafezPoem.join("<br>");
    },
    formattedDate() {
      const day = moment(this.currentDate).format("jD");
      const monthIndex = moment(this.currentDate).jMonth();
      const month = this.persianMonths[monthIndex];
      return `${day} ${month}`;
    },
    ...mapState(["auth"]),
  },
  mounted() {
    this.relaodPage();
    //this.fetchWeather();

    const bInfo = localStorage.getItem("branchinof");
    if (bInfo) {
      this.branchInfo = JSON.parse(bInfo);
    }

    console.log("sscceesstt", this.$store.state.c_set);

    // window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("resize", () => {
      this.window_width = window.innerWidth;
    });
    window.addEventListener("popstate", () => {
      if (this.checkMenu) {
        this.handleBackButton();
      } else if (this.showMenu) {
        this.menuBackAction = true;
        this.showMenuHandler();
        this.menuBackAction = false;
      }
    });

    if (
      this.$route.path === "/" ||
      this.$route.path === "/home" ||
      this.$route.path === "/map-house" ||
      this.$route.path === "/map-amlak"
    ) {
      this.classShow = "FirstPageTopNav";
    } else {
      this.classShow = "topNav";
    }

    const theme = localStorage.getItem("theme");
    if (theme == "dark") {
      this.themeSwithToggleStyle = "left: calc(95% - 18px)";
    } else {
      this.themeSwithToggleStyle = "left:5%";
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("popstate", this.handleBackButton);
  },
  watch: {
    $route: {
      handler(to, from) {
        // بررسی وجود from برای جلوگیری از خطا
        if (!from || from.fullPath === "/") {
          this.TopNavToClass = false;
        } else {
          this.TopNavToClass = true;
        }

        if (
          to.path === "/" ||
          to.path === "/home" ||
          to.path === "/dashboard"
        ) {
          this.classShow = "FirstPageTopNav";
        } else {
          this.classShow = "topNav";
        }
      },
      immediate: true,
    },
  },
  methods: {
    async shareContent() {
      const share_url = this.$store.state.c_set.share_link || "https://cafebazaar.ir/app/com.abarline.amlak?ref=share";
      if (this.$store.state.device == "Desktop") {
        const textToCopy =
          `با سوپر اپلیکیشن شمال املاک می توانید به لیست بهترین فایل های املاک شهرستان بابل دسترسی داشته باشید - ${share_url}`;

        try {
          await navigator.clipboard.writeText(textToCopy);
        } catch {
          const shareUrl = document.createElement("textarea");
          shareUrl.value = textToCopy;
          document.body.appendChild(shareUrl);
          shareUrl.select();
          document.execCommand("copy");
          document.body.removeChild(shareUrl);
        }

        toast("متن اشتراک گذاری کپی شد.", {
          type: "success",
          dangerouslyHTMLString: true,
        });
      } else {
        try {
          await Share.share({
            title: "اشتراک گذاری شمال املاک",
            text: "با سوپر اپلیکیشن شمال املاک می توانید به لیست بهترین فایل های املاک شهرستان بابل دسترسی داشته باشید",
            url: share_url,
            dialogTitle: "شمال املاک",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },

    scrollHandler() {
      const scrollPosition = window.scrollY;
      if (scrollPosition === 0) {
        this.dynamicClass = "stickyBarStatic";
      } else if (scrollPosition > 49) {
        if (scrollPosition < this.lastScrollPosition) {
          this.dynamicClass = "stickyBarStaticSticky";
        } else {
          this.dynamicClass = "stickyBarStaticFixed";
        }
        this.lastScrollPosition = scrollPosition;
      }
      if (window.scrollY > 50) {
        this.classShow = "topNav";
        this.isScrolled = true;
      } else if (this.isScrolled) {
        this.classShow =
          this.$route.fullPath === "/" ||
          this.$route.fullPath === "/home" ||
          this.$route.fullPath === "/home/"
            ? "FirstPageTopNav"
            : "topNav";
        this.isScrolled = false;
      }
    },
    routBack() {
      history.back();
    },
    // async fetchWeather() {
    //   const url =
    //     "https://api.open-meteo.com/v1/forecast?latitude=36.5667&longitude=52.3667&current_weather=true";
    //   try {
    //     const response = await axios.get(url);
    //     this.weather = response.data;
    //   } catch (error) {
    //     console.error("Error fetching weather data:", error);
    //   }
    // },
    // getWeatherIcon(code) {
    //   switch (code) {
    //     case 0:
    //       return "Sun1";
    //     case 1:
    //       return "CloudSunny";
    //     case 2:
    //       return "CloudDrizzle";
    //     case 3:
    //       return "CloudDrizzle";
    //     case 4:
    //       return "CloudDrizzle";
    //     case 5:
    //       return "CloudDrizzle";
    //     default:
    //       return "Sun";
    //   }
    // },
    handleData() {
      this.checkMenu = false;
      this.menuStyles = "transform: translateX(100%);";
      document.body.style = "overflow: auto;";
      this.SliderBar =
        "left: 0;transition: .2s ease-in-out;background: transparent;";
      setTimeout(() => {
        this.SliderBar = "left: 100%;";
      }, 200);
    },
    handleLinkClick(to) {
      if (to == "/submit-house?step=1") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت آگهی وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role == "customer") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_complate &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        } else if (this.$store.state.auth.role == "branch_admin") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.branchInfo &&
            this.branchInfo.is_allowed != "active"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        } else if (this.$store.state.auth.role == "consultant") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
        }
      } else if (to == "/builder-create-post") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت پروژه وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (this.$store.state.auth.role != "builder") {
          toast("ثبت پروژه تنها برای کاربر سازنده ممکن است.", {
            type: "error",
          });
          return;
        } else if (this.$store.state.auth.role == "builder") {
          if (
            this.$store.state.auth.loggedIn &&
            !this.$store.state.auth.is_complate
          ) {
            toast("برای ثبت پروژه اطلاعات پروفایل خود را تکمیل کنید", {
              type: "error",
            });
            return;
          }
          if (
            this.$store.state.auth.loggedIn &&
            this.$store.state.auth.is_allowed == "no"
          ) {
            toast(
              "پروفایل شما تکمیل شده است، اما برای ثبت پروژه نیاز است هویت شما تایید شود.",
              {
                type: "error",
              }
            );
            return;
          }
        }
      }
      if (this.checkMenu) {
        history.replaceState(null, "", to);
        this.$router.replace(to);
        this.checkMenu = false;
        this.menuStyles = "transform: translateX(100%);";
        document.body.style = "overflow: auto;";
        this.SliderBar =
          "left: 0;transition: .2s ease-in-out;background: transparent;";
        setTimeout(() => {
          this.SliderBar = "left: 100%;";
        }, 200);
      }
    },
    BtnOpenSidebar() {
      if (!this.checkMenu) {
        history.pushState(null, "", location.href);
        this.checkMenu = true;
        this.menuStyles = "transform: translateX(0);";
        this.SliderBar = "left: 0";
        document.body.style = "overflow: hidden;";
      }
    },
    BtnCloseSidebar() {
      if (this.checkMenu) {
        if (!this.isBackAction) {
          history.back();
        }
        this.checkMenu = false;
        this.menuStyles = "transform: translateX(100%);";
        document.body.style = "overflow: auto;";
        this.SliderBar =
          "left: 0;transition: .2s ease-in-out;background: transparent;";
        setTimeout(() => {
          this.SliderBar = "left: 100%;";
        }, 200);
      }
    },
    changeTheme() {
      this.darkTheme = !this.darkTheme;
      this.$emit("messageSent", localStorage.getItem("theme"));
      this.themeSwithToggleStyle =
        this.themeSwithToggleStyle === "left:5%"
          ? "left: calc(95% - 18px)"
          : "left:5%";
    },
    open_profile() {
      let role = this.$store.state.auth.role;
      role == "customer"
        ? this.$router.push({ path: "/user-profile" })
        : role == "builder"
        ? this.$router.push({ path: "/user-profile" })
        : this.$router.push({ path: "/profile" });
    },
    relaodPage() {
      setTimeout(() => {
        this.LoadingSkeleton = false;
      }, 200);
    },
    handleBackButton() {
      if (this.checkMenu) {
        this.isBackAction = true;
        this.BtnCloseSidebar();
        this.isBackAction = false;
      }
    },
    profileLogoutHandler() {
      this.BtnCloseSidebar();
      this.$swal
        .fire({
          title: "خروج از حساب کاربری",
          text: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "خروج",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("logout")
                .then((r) => {
                  if (r.data.success == true) {
                    this.$store.state._token = "";
                    this.$store.getters.auth.loggedIn = false;
                    // this.$store.state.c_set = [];
                    localStorage.removeItem("_token");
                    localStorage.removeItem("auth");
                    this.$router.push({ path: "/home" });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-scrollbar {
  position: absolute !important;
  right: 0;
  left: 0;
  bottom: 0;
  top: 70px;
  height: calc(100% - 70px);
}

.closeBtn {
  width: 36px;
  height: 36px;
  background: #ededed;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #000;
  cursor: pointer;
  margin-right: 6px;
}

.swiper {
  width: 100%;
  height: 100%;

  .swiper-slide {
    width: 100%;
    height: 100%;
  }
}

.hafez-dialog >>> .el-dialog__body {
  padding: 0;
}

.hafez-content {
  position: relative;
  background: linear-gradient(to bottom, #fcf6e3, #f3e5ab);
  padding: 10px;
  border-radius: 16px;
  font-family: "IranNastaliq", "Sahel", "Tahoma", sans-serif;
}

.hafez-frame {
  position: relative;
  z-index: 2;
  border: 3px double #aa8844;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.hafez-title {
  text-align: center;
  font-size: 2rem;
  color: #5c3d1d;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.hafez-poem {
  text-align: center;
  font-size: 1.5rem;
  color: #222;
  line-height: 2.5rem;
  margin-bottom: 1.2rem;
}

.hafez-interpretation {
  text-align: center;
  font-size: 1.1rem;
  color: #444;
  margin-bottom: 2rem;
}

.hafez-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.hafezBG {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.4;
  }
}

.el-button.el-button--success.is-plain,
.el-button.el-button--danger.is-plain {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 600px) {
  .switchDark,
  .switchLight {
    display: none;
  }
}
@media (min-width: 1000px) {
  .FirstPageTopNav {
    top: 16px !important;
    .static {
      .topNav__container {
        position: relative;

        .topNav__containerLogo {
          .topNav__logo-wrapper {
            height: 64px !important;
            width: 64px !important;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
        }
        .topNav__container_column {
          &.topNav__container_column--left {
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            margin: 0 auto;
            transform: translateY(-50%);
            width: fit-content;
            background: transparent !important;
            color: #fff !important;
            border-radius: 0 !important;

            .topNav__links_container {
              gap: 20px !important;
              .topNav__link {
                font-size: 0.9rem !important;
              }
            }

            .menuToggling {
              flex-shrink: 0;
            }

            :deep(svg.menuToggling path) {
              stroke: #fff !important;
            }
          }

          &.topNav__container_column--flex-left {
            .ShowWeatherBabol {
              background: transparent !important;
              color: #fff !important;
              margin-left: 16px;
              font-size: 0.9rem;
              margin-top: -2px;
              svg {
                width: 28px !important;
                height: 28px !important;
              }
            }

            .topNav__themeButton_wrapper {
              position: relative;
              margin-right: 0 !important;
              cursor: pointer;
              background: transparent;
              .changeTheme__switch {
                display: none !important;
              }

              .switch_icon {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%) scale(0);
                transition: all 0.2s;

                &.show {
                  transform: translateY(-50%) scale(1);
                }
              }

              :deep(.switch_icon svg) {
                width: 32px !important;
                height: 32px !important;
              }
              :deep(.switch_icon svg path) {
                stroke: #fff !important;
              }
            }

            .ShowUserTemplate1 {
              .ShowUserTemplate {
                margin-right: 16px;
                width: 124px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.85rem;
                color: #fff;
                background: #0096c7;
                border-radius: 8px;
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                  0 4px 6px -4px rgba(0, 0, 0, 0.1);
                transition: all 0.2s;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
